(function () {
  if (window.wlyOkendoRatingReady) return;
  window.wlyOkendoRatingReady = true;
  var CACHE_KEY = 'wlyOkendoAggregate:';
  var CACHE_MS = 3600000;
  var pending = {};

  function formatCount(n, round) {
    if (round) {
      n = Math.floor(n / 100) * 100;
    }
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function readCache(id) {
    try {
      var raw = window.sessionStorage.getItem(CACHE_KEY + id);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (Date.now() - data.t > CACHE_MS) return null;
      return data.v;
    } catch (e) {
      return null;
    }
  }

  function writeCache(id, value) {
    try {
      window.sessionStorage.setItem(CACHE_KEY + id, JSON.stringify({ t: Date.now(), v: value }));
    } catch (e) {}
  }

  function getAggregate(id, done) {
    var cached = readCache(id);
    if (cached) {
      done(cached);
      return;
    }
    if (pending[id]) {
      pending[id].push(done);
      return;
    }
    pending[id] = [done];
    var xhr = new XMLHttpRequest();
    xhr.open('GET', 'https://api.okendo.io/v1/stores/' + encodeURIComponent(id) + '/review_aggregate');
    xhr.onload = function () {
      var result = null;
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          var agg = JSON.parse(xhr.responseText).reviewAggregate;
          var count = agg.reviewCount || agg.ratingAndReviewCount || 0;
          var total = agg.reviewRatingValuesTotal || agg.ratingAndReviewValuesTotal || 0;
          if (count > 0 && total > 0) {
            result = { count: count, score: (Math.round((total / count) * 10) / 10).toFixed(1) };
            writeCache(id, result);
          }
        } catch (e) {}
      }
      var list = pending[id];
      delete pending[id];
      for (var i = 0; i < list.length; i++) {
        if (result) list[i](result);
      }
    };
    xhr.onerror = function () {
      delete pending[id];
    };
    xhr.send();
  }

  function apply(el) {
    var id = el.getAttribute('data-wly-oke');
    if (!id || el.getAttribute('data-wly-oke-done')) return;
    el.setAttribute('data-wly-oke-done', 'true');
    getAggregate(id, function (agg) {
      var round = el.getAttribute('data-wly-oke-round') === 'true';
      var label = el.getAttribute('data-wly-oke-label') || '[count]';
      var countText = label.replace('[count]', formatCount(agg.count, round));
      var scores = el.querySelectorAll('[data-wly-oke-score]');
      var counts = el.querySelectorAll('[data-wly-oke-count]');
      var i;
      for (i = 0; i < scores.length; i++) scores[i].textContent = agg.score;
      for (i = 0; i < counts.length; i++) counts[i].textContent = countText;
    });
  }

  function init(root) {
    var els = (root || document).querySelectorAll('[data-wly-oke]');
    for (var i = 0; i < els.length; i++) apply(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
